/* eslint-disable prettier/prettier */
/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
// import EmailIcon from "@mui/icons-material/Email";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import PhoneIcon from "@mui/icons-material/Phone";
// import ToggleOffIcon from "@mui/icons-material/ToggleOff";
// import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import { TableCell, TableRow } from "@mui/material";
import React from "react";
// import CustomTable from "../../../../components/common/Table";
// import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
// import StatusIcon from "../../../../assets/svg/Status";
import Table from "../../../../components/common/new/Table/Table";
import {
  FRIEND_SEAECH_TABLE_COL,
  MEMBER_REPORT_TABLE_COL,
} from "../../../../contants/table/friendReportSearch";
// import tableStyle from "../../../../theme/styles/table";
// import DeleteIcon from "../../../../assets/svg/Delete";
// import EyeIcon from "../../../../assets/svg/Eye";
// import { PERMISSIONS } from "../../../../contants";
import styles from "./ReportsTable.styles";
import Typography from "../../../../components/common/new/Typography/Typography";
// import NewTable from "../../../member/components/Newtable/NewTable";
import { getSubDivisionDisplayName } from "../../../../utils/helper";

const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
  },
  small: {
    maxWidth: "6rem",
  },
  medium: {
    maxWidth: "10rem",
  },
  large: {
    maxWidth: "25rem",
  },
};
// const roles = [
//   { roleId: 1, name: "fgsdgasdgasdgasdgasdg" },
//   { roleId: 2, name: "chapterSI" },
// ];

const getRows = ({
  searchData,
  currentPage,
  pageSize,
  //   onSelectMember,
  //   onSelectMemberForTransfer,
  //   hasPermission,
  showStatusColumn,
  hasRoleIds,
  // onMemberStatusToggle,
  hashonoraryDistrictChief,
  isMemberReport: isMemberReportProp,
}) =>
  searchData.map((friendInfo, index) => {
    const serialNumber = index + 1 + currentPage * pageSize;
    // OLD logic (kept for future use): member report was inferred only from roleIds/hdc filters.
    // const isMemberReport = Boolean(hasRoleIds || hashonoraryDistrictChief);
    const isMemberReport =
      typeof isMemberReportProp === "boolean"
        ? isMemberReportProp
        : Boolean(hasRoleIds || hashonoraryDistrictChief);
    const roleNames =
      friendInfo?.roles && friendInfo?.roles.map((role) => role.name);

    const truncateText = (text, maxLength) =>
      text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;

    return (
      <TableRow>
        <TableCell style={tabelCellWidth.medium}>
          {" "}
          <Typography style={styles.typoghrphyStyle}>
            {serialNumber}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          {" "}
          <Typography style={styles.typoghrphyStyle}>
            {friendInfo?.id ?? friendInfo.memberId}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          <Typography style={styles.typoghrphyStyle}>
            {friendInfo.fullName}
          </Typography>{" "}
          {/* <br />
          <div style={styles.tableBox}>
            <LocationOnIcon style={tableStyle.locationIcon} />{" "}
            <div style={styles.tableBox}>
              <Typography style={styles.typoghrphyStyle}>
                {friendInfo.addressLine1}
              </Typography>
            </div>
          </div> */}
        </TableCell>
        {/* <TableCell style={tabelCellWidth.medium}>
          <PhoneIcon style={tableStyle.icon} />
          <Typography style={styles.typoghrphyStyle}>
            {" "}
            {friendInfo.mobileNumber}
          </Typography>{" "}
          <br />
          <div style={styles.tableBox}>
            {" "}
            <EmailIcon style={tableStyle.icon} />
            <Typography style={styles.typoghrphyStyle}>
              {friendInfo?.emailId || "-"}
            </Typography>{" "}
          </div>
        </TableCell> */}
        <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {`${friendInfo?.divisionName || "-"} / ${
                getSubDivisionDisplayName(friendInfo?.subDivisionName) || "-"
              }`}
            </Typography>
          </div>
        </TableCell>
        {/* <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {friendInfo?.subDivisionName || "-"}{" "}
            </Typography>
          </div>
        </TableCell> */}
        <TableCell style={tabelCellWidth.large}>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {`${friendInfo?.orgStructure.areaName || "-"}  / ${
                friendInfo?.orgStructure.clusterName || "-"
              } / ${friendInfo?.orgStructure.zoneName || "-"} / ${
                friendInfo?.orgStructure.regionName || "-"
              } / ${friendInfo?.orgStructure.chapterName || "-"} / ${
                friendInfo?.orgStructure.districtName || "-"
              }`}
            </Typography>{" "}
          </div>
        </TableCell>
        {!isMemberReport && (
          <>
            {/* OLD CODE (kept for future use)
            <TableCell style={tabelCellWidth.tiny}>
              <div style={styles.tableBox}>
                <Typography style={styles.typoghrphyStyle}>
                  {friendInfo?.dateOfFirstMeeting
                    ? new Date(friendInfo.dateOfFirstMeeting)
                        .toLocaleDateString("en-GB")
                        .replace(/\//g, "-")
                    : "-"}
                </Typography>
              </div>
            </TableCell>
            <TableCell style={tabelCellWidth.tiny}>
              <div style={styles.tableBox}>
                <Typography style={styles.typoghrphyStyle}>
                  {friendInfo?.deactivationDate
                    ? new Date(friendInfo.deactivationDate).toLocaleString(
                        "en-US",
                        {
                          month: "short",
                          year: "numeric",
                        }
                      )
                    : "-"}
                </Typography>
              </div>
            </TableCell>
            */}

            {/* OLD Date Of First Meeting (kept for future use)
            <TableCell style={tabelCellWidth.tiny}>
              <div style={styles.tableBox}>
                <Typography style={styles.typoghrphyStyle}>
                  {friendInfo?.dateOfFirstMeeting
                    ? new Date(friendInfo.dateOfFirstMeeting)
                        .toLocaleDateString("en-GB")
                        .replace(/\//g, "-")
                    : "-"}
                </Typography>
              </div>
            </TableCell>
            */}

            {/* Date Of First Meeting — uses created_at, format: dd-MM-yyyy */}
            <TableCell style={tabelCellWidth.tiny}>
              <div style={styles.tableBox}>
                <Typography style={styles.typoghrphyStyle}>
                  {friendInfo?.createdAt
                    ? new Date(friendInfo.createdAt)
                        .toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        })
                        .replace(/\//g, "-")
                    : "-"}
                </Typography>
              </div>
            </TableCell>

            {/* OLD FTM Month placeholder (kept for future use)
            <TableCell style={tabelCellWidth.tiny}>
              <div style={styles.tableBox}>
                <Typography style={styles.typoghrphyStyle}>-</Typography>
              </div>
            </TableCell>
            */}

            {/* FTM Months — uses deactivated_at, format: MMM-yy */}
            <TableCell style={tabelCellWidth.tiny}>
              <div style={styles.tableBox}>
                <Typography style={styles.typoghrphyStyle}>
                  {friendInfo?.deactivationDate
                    ? new Date(
                        `${friendInfo.deactivationDate}T00:00:00`
                      ).toLocaleString("en-US", {
                        month: "short",
                        year: "2-digit",
                      })
                    : "-"}
                </Typography>
              </div>
            </TableCell>

            {/* OLD CODE (kept for future use)
            <TableCell style={tabelCellWidth.tiny}>
              <div style={styles.tableBox}>
                <Typography style={styles.typoghrphyStyle}>
                  {friendInfo?.deactivationDate
                    ? new Date(friendInfo.deactivationDate).toLocaleString(
                        "en-US",
                        {
                          month: "short",
                          year: "numeric",
                        }
                      )
                    : "-"}
                </Typography>
              </div>
            </TableCell>
            */}
          </>
        )}

        {/* <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {friendInfo?.orgStructure.areaName || "-"}{" "}
            </Typography>
          </div>
        </TableCell>
        <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {friendInfo?.orgStructure.zoneName || "-"}{" "}
            </Typography>
          </div>
        </TableCell>
        <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {friendInfo?.orgStructure.regionName || "-"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {friendInfo?.orgStructure.chapterName || "-"}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {friendInfo?.orgStructure.districtName || "-"}
            </Typography>{" "}
          </div>
        </TableCell> */}
        {/* <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {friendInfo?.blockName || "-"}{" "}
            </Typography>
          </div>
        </TableCell> */}
        {/* {showStatusColumn && (
          <TableCell style={tabelCellWidth.medium}>
            <div style={styles.tableBox}>
              <StatusIcon label={friendInfo.status} />
            </div>
          </TableCell>
        )} */}
        {/* OLD behavior (kept for future use): mobile + address were shown only when showStatusColumn was true.
            This made Address HelpDesk-only on Member Report page, which is NOT desired now.
        */}
        {/*
        {showStatusColumn && (
          <>
            <TableCell style={tabelCellWidth.medium}>
              <div style={styles.tableBox}>
                <Typography style={styles.typoghrphyStyle}>
                  {friendInfo?.mobileNumber || "-"}{" "}
                </Typography>
              </div>
            </TableCell>
            {isMemberReport && (
              <TableCell style={tabelCellWidth.medium}>
                <div style={styles.tableBox}>
                  <Typography style={styles.typoghrphyStyle}>
                    {friendInfo?.emailId || "-"}{" "}
                  </Typography>
                </div>
              </TableCell>
            )}
            <TableCell>
              <div>
                <Typography style={styles.typoghrphyStyle}>
                  {`${friendInfo?.address.addressLine || "-"} / ${
                    friendInfo?.address.cityName || "-"
                  } / ${friendInfo?.address.stateName || "-"}`}
                </Typography>{" "}
              </div>
            </TableCell>
          </>
        )}
        */}

        {/* New behavior:
            - Mobile + Email are HelpDesk-only (showStatusColumn)
            - Address is visible to everyone on Member Report page
            - Friend report behavior remains unchanged (address hidden when showStatusColumn is false)
        */}
        {showStatusColumn && (
          <>
            <TableCell style={tabelCellWidth.medium}>
              <div style={styles.tableBox}>
                <Typography style={styles.typoghrphyStyle}>
                  {friendInfo?.mobileNumber || "-"}{" "}
                </Typography>
              </div>
            </TableCell>
            {isMemberReport && (
              <TableCell style={tabelCellWidth.medium}>
                <div style={styles.tableBox}>
                  <Typography style={styles.typoghrphyStyle}>
                    {friendInfo?.emailId || "-"}{" "}
                  </Typography>
                </div>
              </TableCell>
            )}
          </>
        )}

        {(isMemberReport || showStatusColumn) && (
          <TableCell>
            <div>
              <Typography style={styles.typoghrphyStyle}>
                {`${friendInfo?.address.addressLine || "-"} / ${
                  friendInfo?.address.cityName || "-"
                } / ${friendInfo?.address.stateName || "-"}`}
              </Typography>{" "}
            </div>
          </TableCell>
        )}
        {hasRoleIds && (
          <TableCell style={tabelCellWidth.medium}>
            <div style={styles.tableBox}>
              {friendInfo?.roles && friendInfo?.roles.length !== 0 ? (
                roleNames.map((role, indexKey) => (
                  <Typography
                    key={indexKey}
                    style={{
                      ...styles.typoghrphyStyle,
                      ...styles.roleChips,
                      color: "#05445E",
                      minWidth: "100px",
                      backgroundColor: "#D4F1F4",
                    }}
                  >
                    <span title={role}>{truncateText(role, 10)}</span>
                  </Typography>
                ))
              ) : (
                <Typography style={styles.typoghrphyStyle}>-</Typography>
              )}
            </div>
          </TableCell>
        )}
        {hashonoraryDistrictChief && (
          <>
            <TableCell style={tabelCellWidth.medium}>
              <div>
                {friendInfo?.honoraryStructures &&
                friendInfo?.honoraryStructures.length > 0 ? (
                  <Typography>
                    {`${friendInfo?.honoraryStructures[0]?.areaName || "-"} / ${
                      friendInfo?.honoraryStructures[0]?.clusterName || "-"
                    } / ${
                      friendInfo?.honoraryStructures[0]?.zoneName || "-"
                    } / ${
                      friendInfo?.honoraryStructures[0]?.regionName || "-"
                    } / ${
                      friendInfo?.honoraryStructures[0]?.chapterName || "-"
                    } / ${
                      friendInfo?.honoraryStructures[0]?.districtName || "-"
                    }`}
                  </Typography>
                ) : (
                  <Typography style={styles.typoghrphyStyle}>-</Typography>
                )}
              </div>
            </TableCell>
            <TableCell style={tabelCellWidth.medium}>
              <div>
                {friendInfo?.honoraryStructures &&
                friendInfo?.honoraryStructures.length > 1 ? (
                  <Typography>
                    {`${friendInfo?.honoraryStructures[1]?.areaName || "-"} / ${
                      friendInfo?.honoraryStructures[1]?.clusterName || "-"
                    } / ${
                      friendInfo?.honoraryStructures[1]?.zoneName || "-"
                    } / ${
                      friendInfo?.honoraryStructures[1]?.regionName || "-"
                    } / ${
                      friendInfo?.honoraryStructures[1]?.chapterName || "-"
                    } / ${
                      friendInfo?.honoraryStructures[1]?.districtName || "-"
                    }`}
                  </Typography>
                ) : (
                  <Typography style={styles.typoghrphyStyle}>-</Typography>
                )}
              </div>
            </TableCell>
          </>
        )}
      </TableRow>
    );
  });

function ReportTable({
  searchData,
  currentPage,
  pageSize,
  onSelectMemberForTransfer,
  onMemberStatusToggle,
  onSelectMember,
  hasPermission,
  showStatusColumn,
  hasRoleIds,
  hashonoraryDistrictChief,
  isMemberReport: isMemberReportProp,
}) {
  // let columns;
  // if (hasRoleIds) {
  //   columns =
  //     showStatusColumn !== true
  //       ? (columns = MEMBER_REPORT_TABLE_COL.filter(
  //           (c) => c.key !== "mobile" && c.key !== "address"
  //         ))
  //       : MEMBER_REPORT_TABLE_COL;
  // } else if (hashonoraryDistrictChief) {
  //   columns =
  //     showStatusColumn !== true
  //       ? (columns = MEMBER_REPORT_TABLE_COL.filter(
  //           (c) => c.key !== "mobile" && c.key !== "address"
  //         ))
  //       : MEMBER_REPORT_TABLE_COL;
  // } else {
  //   columns = showStatusColumn
  //     ? FRIEND_SEAECH_TABLE_COL
  //     : FRIEND_SEAECH_TABLE_COL.filter(
  //         (c) => c.key !== "mobile" && c.key !== "address"
  //       );
  // }
  let columns;

  // OLD logic (kept for future use): member report columns were inferred only from roleIds/hdc filters.
  // const isMemberReport = Boolean(hasRoleIds || hashonoraryDistrictChief);

  const isMemberReport =
    typeof isMemberReportProp === "boolean"
      ? isMemberReportProp
      : Boolean(hasRoleIds || hashonoraryDistrictChief);

  if (isMemberReport && hasRoleIds && hashonoraryDistrictChief) {
    // Show Role, Honorary District Chief 1, and Honorary District Chief 2 columns
    columns = showStatusColumn
      ? MEMBER_REPORT_TABLE_COL
      : MEMBER_REPORT_TABLE_COL.filter(
          // OLD behavior (kept for future use): address was also removed for non-helpdesk.
          // (c) => c.key !== "mobile" && c.key !== "email" && c.key !== "address"
          (c) => c.key !== "mobile" && c.key !== "email"
        );
  } else if (isMemberReport && hasRoleIds) {
    // Show only Role column
    columns = showStatusColumn
      ? MEMBER_REPORT_TABLE_COL.filter(
          (c) =>
            c.key !== "honoraryDistrictChief1" &&
            c.key !== "honoraryDistrictChief2"
        )
      : MEMBER_REPORT_TABLE_COL.filter(
          (c) =>
            c.key !== "mobile" &&
            c.key !== "email" &&
            // OLD behavior (kept for future use): address was also removed for non-helpdesk.
            // c.key !== "address" &&
            c.key !== "honoraryDistrictChief1" &&
            c.key !== "honoraryDistrictChief2"
        );
  } else if (isMemberReport && hashonoraryDistrictChief) {
    // Show only Honorary District Chief 1 and Honorary District Chief 2 columns
    columns = showStatusColumn
      ? MEMBER_REPORT_TABLE_COL.filter((c) => c.key !== "role")
      : MEMBER_REPORT_TABLE_COL.filter(
          (c) =>
            c.key !== "mobile" &&
            c.key !== "email" &&
            // OLD behavior (kept for future use): address was also removed for non-helpdesk.
            // c.key !== "address" &&
            c.key !== "role"
        );
  } else if (isMemberReport) {
    // Member Report default (no roleIds/hdc filters applied)
    columns = showStatusColumn
      ? MEMBER_REPORT_TABLE_COL.filter(
          (c) =>
            c.key !== "role" &&
            c.key !== "honoraryDistrictChief1" &&
            c.key !== "honoraryDistrictChief2"
        )
      : MEMBER_REPORT_TABLE_COL.filter(
          (c) =>
            c.key !== "mobile" &&
            c.key !== "email" &&
            // OLD behavior (kept for future use): address was also removed for non-helpdesk.
            // c.key !== "address" &&
            c.key !== "role" &&
            c.key !== "honoraryDistrictChief1" &&
            c.key !== "honoraryDistrictChief2"
        );
  } else {
    // Neither hasRoleIds nor hashonoraryDistrictChief is true
    columns = showStatusColumn
      ? FRIEND_SEAECH_TABLE_COL
      : FRIEND_SEAECH_TABLE_COL.filter(
          (c) => c.key !== "mobile" && c.key !== "address"
        );
  }

  return (
    <div style={styles.container}>
      <Table
        scrollable
        columns={columns}
        rows={getRows({
          searchData,
          currentPage,
          pageSize,
          onSelectMemberForTransfer,
          onSelectMember,
          hasPermission,
          onMemberStatusToggle,
          showStatusColumn,
          hasRoleIds,
          hashonoraryDistrictChief,
          isMemberReport,
        })}
        tableBodyTheme="#F6F6F6"
        tableHeadCellStyle={{
          ...styles.tableHeadCells,
          textAlign: "center",
        }}
      />
    </div>
  );
}

export default ReportTable;
